import {css} from "@emotion/react";

import {styled} from "@atg-ui/toolkit/theme";

import {imageBorder} from "../Image/Image.styles";

import type {BorderProps} from "../../../types/image";

export const createBorderOptions = (
    rounded: boolean,
    borderOptions?: BorderProps,
): BorderProps | undefined => {
    const borderRadius = rounded ? "50%" : borderOptions?.borderRadius;
    return borderOptions ? {...borderOptions, borderRadius} : {borderRadius};
};

const wrapper = (height: string) => css`
    padding-top: ${height};
    overflow: hidden;
`;

export const ImageContainer = styled("div")<{
    height?: string;
    borderOptions?: BorderProps;
}>(
    ({theme, height, borderOptions}) => css`
        width: 100%;
        position: relative;
        ${height && wrapper(height)};
        ${borderOptions && imageBorder({theme, ...borderOptions})};
        ${borderOptions?.borderRadius && `border-radius: ${borderOptions.borderRadius};`};
    `,
);

export default ImageContainer;
